module.exports = __webpack_public_path__ + "img/gift4-01-c03-k1.8bb2d2f7.png";